/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_TitleInputs */

const en_pc_alt_pick_title = /** @type {(inputs: Pc_Alt_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which one should you pick?`)
};

const zh_pc_alt_pick_title = /** @type {(inputs: Pc_Alt_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该选哪一个？`)
};

/**
* | output |
* | --- |
* | "Which one should you pick?" |
*
* @param {Pc_Alt_Pick_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_title = /** @type {((inputs?: Pc_Alt_Pick_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_title(inputs)
	return zh_pc_alt_pick_title(inputs)
});
export { pc_alt_pick_title as "pc.alt.pick_title" }